// shortEncrypt.js

const BASE62_CHARS = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

// Encode number to Base62
const encodeBase62 = (num) => {
    let result = "";
    while (num > 0) {
        result = BASE62_CHARS[num % 62] + result;
        num = Math.floor(num / 62);
    }
    return result.padStart(5, '0'); // always 5 chars
};

// Decode Base62 to number
const decodeBase62 = (str) => {
    let result = 0;
    for (let i = 0; i < str.length; i++) {
        result = result * 62 + BASE62_CHARS.indexOf(str[i]);
    }
    return result;
};

// Secret key (number)
const SECRET_KEY = 123; // can be any small number

// Encrypt
export const encryptUserId = (userId) => {
    const xorValue = userId ^ SECRET_KEY;
    return encodeBase62(xorValue);
};

// Decrypt
export const decryptUserId = (code) => {
    const decoded = decodeBase62(code);
    return decoded ^ SECRET_KEY;
};


// setDecrypted(decryptUserId(encrypted));
// setEncrypted(encryptUserId(Number(id)));
